var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 25,
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24s.92 7.54 2.56 10.78z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h48v48H0z"
})));
export { SvgGoogleLogo as ReactComponent };
export default "/static/explore/52637a98b6af851089caccbad8aa8eb115d3d065/_next/static/images/GoogleLogo-22bd3e515b7dcc0148ea0ebe7278c85b.svg";